/* eslint-disable @typescript-eslint/no-unused-vars */
type StringOfLength<_Min, _Max> = string & {
  __value__: never;
};
/* eslint-enable @typescript-eslint/no-unused-vars */

const isStringOfLength = <Min extends number, Max extends number>(
  str: string,
  min: Min,
  max: Max
): str is StringOfLength<Min, Max> => str.length >= min && str.length <= max;

export default function stringOfLength<Min extends number, Max extends number>(
  input: unknown,
  min: Min,
  max: Max
): StringOfLength<Min, Max> {
  if (typeof input !== 'string') throw new Error('invalid input');
  if (!isStringOfLength(input, min, max)) throw new Error(`input is not between specified min:${min} and max:${max}`);
  return input;
}
